import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Nav from "./ui/Nav";
import Footer from "./ui/Footer";
import Seo from "./ui/Seo";
import Home from "./pages/Home";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Help from "./pages/Help";
import Pricing from "./pages/Pricing";
import Refunds from "./pages/Refunds";
import DeleteAccount from "./pages/DeleteAccount";
import Contact from "./pages/Contact";
import NotFound from "./templates/NotFound";
import ContentRoute from "./templates/ContentRoute";
import { CONTENT_ROUTES } from "./data/registry";
import { settlePrerender } from "./lib/prerender";

/**
 * Scroll to the top on a route change, but leave hash navigation alone — the
 * browser's own anchor handling already lands in the right place.
 */
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}

export default function App() {
  // After the first commit, so the hero has already read the flag.
  useEffect(settlePrerender, []);

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Seo />
      <ScrollToTop />
      <Nav />
      <main id="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/help" element={<Help />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/refunds" element={<Refunds />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/contact" element={<Contact />} />
          {CONTENT_ROUTES.map((entry) => (
            <Route
              key={entry.path}
              path={entry.path}
              element={<ContentRoute entry={entry} />}
            />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
